import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Redirect, Switch, Route } from 'react-router-dom'
import MainContent from '../common/MainContent'
import InternalReports from '../InternalReports'
import BillingReport from '../BillingReport'
import PageWidth from '../PageWidth'
import { ROLES } from '../../constants'
import {
  BILLING_REPORT_SLUG,
  INTERNAL_REPORTS,
} from '../../constants/internalReports'

const InternalReportsPage = ({
  accountProfile,
  match,
}) => {
  const role = accountProfile.role
  if (role !== ROLES.SUPER_ADMIN && role !== ROLES.PILLAR_ADMIN) {
    return <Redirect to="/dashboard" />
  }

  const { url } = match
  const billingReport = INTERNAL_REPORTS.find(
    r => r.slug === BILLING_REPORT_SLUG
  )

  return (
    <MainContent>
      <div className="InternalReportsPage with-side-nav">
        <PageWidth>
          <Switch>
            <Route
              path={url}
              exact
              render={() => (
                <Fragment>
                  <Helmet>
                    <title>Internal Reports</title>
                  </Helmet>
                  <InternalReports reports={INTERNAL_REPORTS} baseUrl={url} />
                </Fragment>
              )}
            />
            <Route
              path={`${url}/${BILLING_REPORT_SLUG}`}
              exact
              render={() => (
                <Fragment>
                  <Helmet>
                    <title>Billing Report</title>
                  </Helmet>
                  <BillingReport
                    baseUrl={url}
                    description={billingReport.description}
                  />
                </Fragment>
              )}
            />
          </Switch>
        </PageWidth>
      </div>
    </MainContent>
  )
}

InternalReportsPage.propTypes = {
  accountProfile: PropTypes.shape({
    role: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default InternalReportsPage
